/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pipelines_Map_StagesInputs */

const cs_pipelines_map_stages = /** @type {(inputs: Pipelines_Map_StagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namapujte každou fázi na fázi v cílové pipeline`)
};

const en_pipelines_map_stages = /** @type {(inputs: Pipelines_Map_StagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Map each stage to a stage in the target pipeline`)
};

/**
* | output |
* | --- |
* | "Map each stage to a stage in the target pipeline" |
*
* @param {Pipelines_Map_StagesInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pipelines_map_stages = /** @type {((inputs?: Pipelines_Map_StagesInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pipelines_Map_StagesInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pipelines_map_stages(inputs)
	return cs_pipelines_map_stages(inputs)
});